import { makeVar } from '@apollo/client'
import Cookie from 'js-cookie'

import config from './config'

const urlParams = new URLSearchParams(window.location.search)

export const quoteId = makeVar<string | undefined>(urlParams.get('quote_id') || Cookie.get(config.quoteIdCookieName))
